import { render, staticRenderFns } from "./DeleteRecipientModal.vue?vue&type=template&id=73c96266&lang=pug"
import script from "./DeleteRecipientModal.vue?vue&type=script&lang=js"
export * from "./DeleteRecipientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports